import { mapActions, mapGetters, mapMutations } from 'vuex'
import general from '../general/index.vue'

export default {
    name: 'setting-analysis-options-dialog-view',
    data () {
        return {
            dialog: true
        }
    },
    components: {
        general
    },
    watch: {
        openDialogView () {
            this.dialog = this.openDialogView
        }
    },
    computed: {
        ...mapGetters({
            currentItem: 'settingAnalysisOptions/currentItem',
            openDialogView: 'settingAnalysisOptions/openDialogView',
            editId: 'settingAnalysisOptions/editId'
        }),
        dialogTitle () {
            if (this.currentItem && this.currentItem.key) {
                return this.currentItem.key
            }

            return 'Create'
        }
    },
    created () {
        if (this.editId) {
            this.fetchItem()
        }
    },
    methods: {
        ...mapActions({
            fetchItem: 'settingAnalysisOptions/GET_LIST_ITEM'
        }),
        ...mapMutations({
            changeDialogView: 'settingAnalysisOptions/CHANGE_DIALOG_VIEW',
            changeEditId: 'settingAnalysisOptions/CHANGE_EDIT_ID',
            setContent: 'settingAnalysisOptions/SET_ITEM'
        }),
        changeCloseDialog () {
            this.dialog = false

            this.changeDialogView(false)
            this.changeEditId('')
            this.setContent(null)
        }
    },
    destroyed () {
        this.setContent(null)
    }
}
